import React from "react";
import InvalidMessage from "venuescanner-js/react/components/Form/Notifications/InvalidMessage";
import classes from "./style.module.scss";

function Toggle(props) {
  const {
    name,
    register = () => {},
    errors = {},
    touched = {},
    value,
    handleChange,
    disabled = false,
    includeValidity = false,
  } = props;

  return (
    <div
      className={(!touched || touched[name]) && errors[name] && "form-error"}
    >
      <label className={classes.toggle}>
        <input
          name={name}
          {...register(name)}
          checked={value === "on" || value === true}
          type="checkbox"
          disabled={disabled}
          onChange={handleChange}
        />
        <span className={classes.toggle__switch}></span>
      </label>

      {includeValidity && (
        <InvalidMessage error={(!touched || touched[name]) && errors[name]} />
      )}
    </div>
  );
}

export default Toggle;
